import React, { useEffect, useState } from 'react';

const Services = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetch('http://localhost:5000/api/services')
      .then(res => res.json())
      .then(data => setServices(data))
      .catch(err => console.error('Error fetching services:', err));
  }, []);

  const serviceIcons = {
    1: '💍',
    2: '⚒️', 
    3: '📜',
    4: '⌚',
    5: '💎'
  };

  return (
    <section id="services" className="py-24 px-6 bg-cream relative">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23b8860b' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-16">
          <span className="font-montserrat text-xs tracking-super-wide text-gold-600 uppercase">Our Expertise</span>
          <h2 className="font-playfair text-5xl md:text-6xl text-charcoal mt-4 mb-6">
            Services We Offer
          </h2>
          <div className="w-24 h-px bg-gradient-gold mx-auto"></div>
          <p className="font-cormorant text-xl text-charcoal/70 max-w-3xl mx-auto mt-6">
            Serving Cumming, Alpharetta, and all of North Georgia with direct pricing, on-site craftsmanship, and service that can't be found anywhere else
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group relative bg-white p-10 shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Hover effect background */}
              <div className="absolute inset-0 bg-gradient-to-br from-gold-50 to-gold-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    <div className="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center text-3xl group-hover:scale-110 transition-transform duration-500">
                      <span className="text-white text-3xl">{serviceIcons[service.id]}</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="font-playfair text-2xl text-charcoal mb-3 group-hover:text-gold-700 transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="font-montserrat text-charcoal/70 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>

              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-24 h-24 opacity-10 group-hover:opacity-20 transition-opacity duration-500">
                <div className="absolute top-2 right-2 text-6xl text-gold-500">✦</div>
              </div>
            </div>
          ))}
        </div>

        {/* Special Feature */}
        <div className="bg-charcoal p-12 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-gold-900/20 via-gold-600/10 to-gold-900/20"></div>
          <div className="relative text-center">
            <h3 className="font-playfair text-3xl text-white mb-4">
              Lifetime Warranty
            </h3>
            <p className="font-cormorant text-xl text-white/80 mb-8 max-w-2xl mx-auto">
              Every custom piece comes with our exclusive lifetime warranty, 
              a testament to our confidence in our craftsmanship and commitment to your satisfaction.
            </p>
            <div className="flex flex-wrap justify-center gap-8 text-white/70">
              <div className="flex items-center space-x-2">
                <span className="text-gold-400">✓</span>
                <span className="font-montserrat text-sm">Free Annual Inspection</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-gold-400">✓</span>
                <span className="font-montserrat text-sm">Complimentary Cleaning</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-gold-400">✓</span>
                <span className="font-montserrat text-sm">Priority Repairs</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;